import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { calendarAsMemberQueryKeys } from "../calendarAsMember";
import { eventOccurrenceAsMemberQueryKeys } from "./eventOccurrenceAsMemberQueryKeys";

export const useMutationLateCancelAsMember = ({ api }: { api: ApiType }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      rsvpId,
      paymentMethodId,
    }: {
      rsvpId: number;
      paymentMethodId?: string;
    }) =>
      (
        await api.customerOccurrenceApi.lateCancel(rsvpId, {
          paymentMethodId,
        })
      ).data,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: eventOccurrenceAsMemberQueryKeys.all(),
      });
      await queryClient.invalidateQueries({
        queryKey: calendarAsMemberQueryKeys.eventOccurrences(),
      });
      await queryClient.invalidateQueries({
        queryKey: calendarAsMemberQueryKeys.userMemberBookingAgenda(),
      });
    },
  });
};
